<template>
  <div v-if="!loading">
    <form>
      <v-layout
        wrap
        align-center
        justify-space-between
      >
        <v-flex
          xs12
          md5
        >
          <v-alert
            color="warning"
            dark
            dismissible
          >
            Prosím skontrolujte tento údaj, či platí za posledných 24 mesiacov.
          </v-alert>
          <v-select
            v-model="form.disciplinarne_tresty"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.disciplinarne_tresty"
            label="Disciplinárne tresty (počet - časové obdobie 24  mesiacov pred hodnotením)"
            name="Disciplinárne tresty (počet - časové obdobie 24  mesiacov pred hodnotením)"
            :error-messages="
              errors.collect(
                'Disciplinárne tresty (počet - časové obdobie 24  mesiacov pred hodnotením)'
              )
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('disciplinarne_tresty')"
          />
        </v-flex>

        <v-flex
          xs12
          md5
        >
          <v-alert
            color="warning"
            dark
            dismissible
          >
            Prosím skontrolujte tento údaj, či platí za posledných 24 mesiacov.
          </v-alert>

          <v-select
            v-model="form.disciplinarne_odmeny"
            v-validate="'required'"
            :disabled="form.closed"
            :items="selects.disciplinarne_odmeny"
            label="Disciplinárne odmeny (počet - časové obdobie 24  mesiacov pred hodnotením)"
            name="Disciplinárne odmeny (počet - časové obdobie 24  mesiacov pred hodnotením)"
            :error-messages="
              errors.collect(
                'Disciplinárne odmeny (počet - časové obdobie 24  mesiacov pred hodnotením)'
              )
            "
            required
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('disciplinarne_odmeny')"
          />
        </v-flex>
      </v-layout>

      <v-select
        v-model="form.zamietnute_ziadosti_o_podm"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.zamietnute_ziadosti_o_podm"
        label="Zamietnuté žiadosti o podmienečné prepustenie (historický údaj z minulého časového obdobia max.  5 rokov pred dátumom hodnotenia)"
        name="Zamietnuté žiadosti o podmienečné prepustenie (historický údaj z minulého časového obdobia max.  5 rokov pred dátumom hodnotenia)"
        :error-messages="
          errors.collect(
            'Zamietnuté žiadosti o podmienečné prepustenie (historický údaj z minulého časového obdobia max.  5 rokov pred dátumom hodnotenia)'
          )
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('zamietnute_ziadosti_o_podm')"
      />

      <v-select
        v-model="form.prijatie_zodpovednosti"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.prijatie_zodpovednosti"
        label="Prijatie zodpovednosti za páchanú trestnú činnosť"
        name="Prijatie zodpovednosti za páchanú trestnú činnosť"
        :error-messages="
          errors.collect('Prijatie zodpovednosti za páchanú trestnú činnosť')
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('prijatie_zodpovednosti')"
      />

      <v-select
        v-model="form.predatorske_spravanie"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.predatorske_spravanie"
        label="Predátorské správanie"
        name="Predátorské správanie"
        :error-messages="errors.collect('Predátorské správanie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('predatorske_spravanie')"
      />

      <v-select
        v-model="form.plnenie_programu"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.plnenie_programu"
        label="Plnenie programu zaobchádzania"
        name="Plnenie programu zaobchádzania"
        :error-messages="errors.collect('Plnenie programu zaobchádzania')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('plnenie_programu')"
      />

      <v-select
        v-model="form.rodina_a_vztahy"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.rodina_a_vztahy"
        label="Rodina a vzťahy počas aktuálneho výkonu trestu odňatia slobody"
        name="Rodina a vzťahy počas aktuálneho výkonu trestu odňatia slobody"
        :error-messages="
          errors.collect(
            'Rodina a vzťahy počas aktuálneho výkonu trestu odňatia slobody'
          )
        "
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('rodina_a_vztahy')"
      />

      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa
            dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="1"
            max="3"
            ticks="always"
            :color="color"
            :readonly="form.closed"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-select
        v-model="form.nepravdive_zavadzajuce"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.nepravdive_zavadzajuce"
        label="Nepravdivé/zavádzajúce informácie"
        name="Nepravdivé/zavádzajúce informácie"
        :error-messages="errors.collect('Nepravdivé/zavádzajúce informácie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('nepravdive_zavadzajuce')"
      />

      <v-divider class="mt-10" />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>
    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <tooltip-component
        :dialog_item="dialog_item"
        :on_close="closeTooltipDialog"
      />
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="complex" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import { Tooltips } from "@/assets/tooltips";
import TooltipComponent from "./TooltipComponent.vue";
import FormSkeleton from "../../components/FormSkeleton.vue";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();
const tooltips = new Tooltips();

export default {
  $_veeValidate: {
    validator: "new",
  },

  components: {
    "tooltip-component": TooltipComponent,
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: [],
    },

    form: {
      id: null,
      disciplinarne_tresty: "",
      disciplinarne_odmeny: "",
      zamietnute_ziadosti_o_podm: "",
      prijatie_zodpovednosti: "",
      predatorske_spravanie: "",
      plnenie_programu: "",
      rodina_a_vztahy: "",
      expertne_posudenie: "1",
      nepravdive_zavadzajuce: "",
    },

    craItem: {},

    selects: {
      disciplinarne_tresty: ["0", "1", "2-3", "4 a viac"],
      disciplinarne_odmeny: ["0", "1 a viac", "nehodnotiteľné"],

      zamietnute_ziadosti_o_podm: [
        "odsúdenému súd zamietol žiadosť o podmienečné prepustenie",
        "odsúdenému súd nezamietol žiadosť o podmienečné prepustenie",
      ],

      prijatie_zodpovednosti: [
        "plne akceptuje svoju zodpovednosť za kriminálne správanie",
        "akceptuje nejakú zodpovednosť ale minimalizuje (bagatelizuje) a/alebo racionalizuje (zdôvodňuje)",
        "odmieta akúkoľvek zodpovednosť, obviňuje iných a okolnosti",
      ],

      predatorske_spravanie: [
        "nie je manipulatívny ani vykorisťovateľský vo vzťahu k ostatným odsúdeným, zamestnancom ZVJS, ostatným osobám, nezaujíma ho využívanie iných pre vlastné záujmy",
        "prejavuje určité kriminálne hodnoty a postoje (napr. „iba silný prežije“ a pod.), ale zjavne neťaží  z ostatných pre svoj vlastný prospech",
        "vydiera alebo manipuluje ostatných pre svoj vlastný prospech (cela, peniaze, strava, tabak, káva a pod.) bez ohľadu na ich práva a potreby",
      ],

      plnenie_programu: [
        "odsúdený plní program zaobchádzania",
        "odsúdený čiastočne plní program zaobchádzania",
        "odsúdený neplní program zaobchádzania",
        "nehodnotiteľné",
      ],

      rodina_a_vztahy: [
        "udržiava kontakt s rodinnými príslušníkmi a/alebo inými príp. blízkymi osobami, pričom tento kontakt možno charakterizovať ako intenzívny a pravidelný",
        "udržiava kontakt s rodinnými príslušníkmi a/alebo inými príp. blízkymi osobami",
        "nemá žiadny kontakt s rodinnými príslušníkmi a/alebo inými príp. blízkymi osobami",
      ],

      expertne_posudenie: ["malá", "stredná", "vysoká"],

      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
      ],
    },

    manual: tooltips.peniterciarneZaobchadzanie,
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    },
  },

  created() {
    this.getPenitenciarneZaobchadzanie();
  },

  methods: {
    closeTooltipDialog() {
      this.dialog = false;
    },

    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },
    clear() {
      this.form.id = null;
      this.form.skore = 0;
      this.form.disciplinarne_tresty = "";
      this.form.disciplinarne_odmeny = "";
      this.form.zamietnute_ziadosti_o_podm = "";
      this.form.prijatie_zodpovednosti = "";
      this.form.predatorske_spravanie = "";
      this.form.plnenie_programu = "";
      this.form.rodina_a_vztahy = "";
      this.form.expertne_posudenie = "1";
    },
    getPenitenciarneZaobchadzanie() {
      this.loading = true;
      var numberOfItemsToLoad = 2;
      apiService
        .getPenitenciarneZaobchadzanie(this.$route.params.id)
        .then((response) => {
          this.form = response;
          numberOfItemsToLoad--;
          if (numberOfItemsToLoad == 0) {
            this.loading = false;
          }
        });
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.craItem = response;
        numberOfItemsToLoad--;
        if (numberOfItemsToLoad == 0) {
          this.loading = false;
        }
      });
    },
    updateItem() {
      apiService
        .updatePenitenciarneZaobchadzanie(this.form, this.$route.params.id)
        .then(
          () => {
            this.snackbar_saved = true;
            this.$root.$emit("ecra_part_updated");
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
    openItem() {
      apiService
        .updatePenitenciarneZaobchadzanie(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          (response) => {
            this.snackbar_saved = true;
            this.form = response;
            this.$root.$emit("ecra_part_updated");
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },

    closeItem() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updatePenitenciarneZaobchadzanie(
                this.form,
                this.$route.params.id
              )
              .then(
                (response) => {
                  this.snackbar_saved = true;
                  this.form = response;
                  this.$root.$emit("ecra_part_updated");
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },
  },
};
</script>
